import React from "react";

// Monochrome, hairline-framed luxury badges. No brand colors — uniform silver typography.
const Mark = ({ label, title }) => (
    <span
        title={title}
        aria-label={title}
        data-testid={`pay-${title.toLowerCase().replace(/\s+/g, "-")}`}
        className="inline-flex items-center justify-center h-6 px-2.5 text-[0.58rem] tracking-[0.22em] uppercase text-brand-silver/80 border border-white/12 hover:border-brand-gold/60 hover:text-brand-gold transition-colors duration-500 font-sans"
        style={{ letterSpacing: "0.22em" }}
        role="listitem"
    >
        {label}
    </span>
);

export const PaymentMarks = ({ className = "" }) => (
    <div
        className={`flex flex-wrap items-center gap-1.5 ${className}`}
        data-testid="payment-marks"
        role="list"
        aria-label="Accepted payment methods"
    >
        <Mark title="Visa" label="Visa" />
        <Mark title="Mastercard" label="Mastercard" />
        <Mark title="American Express" label="Amex" />
        <Mark title="Discover" label="Discover" />
        <Mark title="Diners Club" label="Diners" />
        <Mark title="JCB" label="JCB" />
        <Mark title="UnionPay" label="UnionPay" />
        <Mark title="Apple Pay" label="Apple Pay" />
        <Mark title="Google Pay" label="Google Pay" />
        <Mark title="Wire / ACH" label="Wire · ACH" />
    </div>
);

export default PaymentMarks;
